import {
  Card,
  CardContent,
  Grid,
  Typography,
  Accordion,
  AccordionItem,
  AccordionTitle,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel
} from "@deere/fuel-react";
import { useState, useEffect } from "react";
import SelfServiceButtons from "../SelfServiceButtons";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
import DetailsTab from "../tabs/SectionStep.Details";
import LinksTab from "../tabs/SectionStep.Links";
import TranslationsTab from "../tabs/SectionStep.Translations";
import { SELFSERVICE_FIELD_NAMES, DETAILS, LINKS, TRANSLATIONS, ENV_PROD, DEFAULT_PART_SECTION_PAYLOAD, SURVEYPART_SECTION_TYPES, SAVING_DATA, CRS_SURVEY_TEMPLATES } from "../../../../utils/surveyLiterals";
import { validateSectionStep } from "../../../../utils/validation";
import { CURRENT_ENV } from '../../../../utils/constEnvVariables';
import SelfServiceLoader from "../SelfServiceLoader";

const SectionStep = ({ sectionError, setSectionError, currentStep, activeStep, setActiveStep, setPayloadData, payloadData, languageList }) => {
  const [sections, setSections] = useState([]);
  const [loader, setLoader] = useState({isLoading: false, message: ""});

  useEffect(() => {
    if (payloadData.sections.length === 0) addNewhandler();
  }, []);

  useEffect(() => {
    //Setting isDefault & isExpandable Property for sections in case of Part Template scenario
    //It is getting used to mark certain predefined sections as "Default" & disable actions for them
    const sections = [...payloadData.sections];
    sections.forEach((sec) => {
      const index = DEFAULT_PART_SECTION_PAYLOAD.findIndex((defSection) => defSection.type === sec.type);
      if (index > -1) {
        sec.isDefault = sec.isAddedPart
          ? (sec.isDefault !== undefined ? sec.isDefault : false)
          : DEFAULT_PART_SECTION_PAYLOAD[index].isDefault;
        sec.isExpandable = DEFAULT_PART_SECTION_PAYLOAD[index].isExpandable;
      }
    });
    setSections(sections);
  }, [payloadData.sections]);

  const addNewhandler = () => {
    const sectionCount = payloadData.sections.length + 1;
    const objSection = {
      description: "",
      active: true,
      code: payloadData.code + "_SEC" + sectionCount,
      showOrder: sectionCount,
      longDescription: "",
      questions: [],
      type: payloadData.templateType === CRS_SURVEY_TEMPLATES.PART ? SURVEYPART_SECTION_TYPES.QUESTIONS : "",
      translations: [],
      links: []
    };
    setPayloadData((prevState) => {
      const newSections = [...prevState.sections, objSection];
      return { ...prevState, sections: newSections };
    });
    setSectionError({ show: false, message: "" });
  };

  const addNewParthandler = () => { 
    const sectionCount = payloadData.sections.length + 1;
    const objSection = {
      description: "",
      active: true,
      code: payloadData.code + "_SEC" + sectionCount,
      showOrder: sectionCount,
      longDescription: "",
      questions: [],
      type: SURVEYPART_SECTION_TYPES.PART,
      translations: [],
      links: [],
      isDefault: false,
      isAddedPart: true //add UI variables, no need to pass to DB
    };
    setPayloadData((prevState) => {
      const newSections = [...prevState.sections, objSection];
      return { ...prevState, sections: newSections };
    });
    setSectionError({ show: false, message: "" });
  };

  const changeHandler = (event, sectionCode) => {
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((section) => section.code === sectionCode);
      const newSections = [...prevState.sections];
      switch (event.target.name) {
        case SELFSERVICE_FIELD_NAMES.description:
          newSections[sectionIndex].description = event.target.value;
          break;
        case SELFSERVICE_FIELD_NAMES.longDescription:
          newSections[sectionIndex].longDescription = event.target.value;
      }
      return { ...prevState, sections: newSections };
    });
    setSectionError({ show: false, message: "" });
  };

  const deleteSection = (section) => {
    setPayloadData((prevState) => {
      const newSections = prevState.sections.filter((sec) => sec.code !== section.code);
      newSections.forEach((sec) => {
        if (sec.showOrder > section.showOrder) {
          const sectionCount = sec.showOrder - 1;
          sec.showOrder = sectionCount;
          sec.code = sec.code.split("_SEC")[0] + "_SEC" + sectionCount;
        }
      });
      return { ...prevState, sections: newSections };
    });
    setSectionError({ show: false, message: "" });
  };

  const fnValidate = (publishHandler) => {
    const isPartTemplate = payloadData.templateType === CRS_SURVEY_TEMPLATES.PART;
    const error = validateSectionStep(payloadData, isPartTemplate);
    error.show
      ? setSectionError(error)
      : (setLoader({ isLoading: true, message: SAVING_DATA }), publishHandler(payloadData));
  };


  return (
    <>
      <Card>
        <CardContent>
          {loader.message !== "" && <SelfServiceLoader loader={loader} />}
          {loader.message === "" && <Grid item>
            <Typography variant="h1" mb={4}>
              {currentStep.step} - {currentStep.title}
            </Typography>
            <Accordion dense>
              {sections
                  .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                  .map((section) => {
                    const showDefaultLabel = section.isDefault && !section.isAddedPart
                        return (
                          <AccordionItem key={section.code}>
                        <Grid container>
                          <Grid item xs={11}>
                            <AccordionSummary sx={section.isExpandable !== undefined && !section.isExpandable && { "& .MuiAccordionSummary-expandIconWrapper": { visibility: "hidden" } }}>
                              <AccordionTitle>
                                {section.description
                                  ? showDefaultLabel
                                    ? `${section.showOrder}. ${section.description} (Default)`
                                    : `${section.showOrder}. ${section.description}`
                                  : `Section ${section.showOrder}`}
                              </AccordionTitle>
                            </AccordionSummary>
                          </Grid>
                          <Grid item xs={1} textAlign="center" alignContent="center">
                            {(!section.isDefault || (section.type === SURVEYPART_SECTION_TYPES.PART && section.isAddedPart))&& (
                              <IconButton aria-label="Delete" onClick={() => deleteSection(section)}>
                                <DeleteIcon />
                              </IconButton>
                            )}
                          </Grid>
                        </Grid>
                        <AccordionDetails hidden={section.isExpandable !== undefined && !section.isExpandable}>
                          <Tabs>
                            <TabList>
                              <Tab label={DETAILS} />
                              { CURRENT_ENV !== ENV_PROD && <Tab label={LINKS} />}
                              {payloadData.language && payloadData.language.length > 1 && <Tab label={TRANSLATIONS} />}
                            </TabList>
                            <TabPanels>

                                <TabPanel>
                                  <DetailsTab section={section} changeHandler={changeHandler} />
                                </TabPanel>

                              { CURRENT_ENV !== ENV_PROD && (
                                <TabPanel>
                                  <LinksTab section={section} payloadData={payloadData} setPayloadData={setPayloadData} setSectionError={setSectionError} />
                                </TabPanel>
                              )}
                              {payloadData.language && payloadData.language.length > 1 && (
                                <TabPanel>
                                    <TranslationsTab section={section} payloadData={payloadData} setPayloadData={setPayloadData} setSectionError={setSectionError} languageList={languageList} />
                                </TabPanel>
                                )}
                            </TabPanels>
                          </Tabs>
                        </AccordionDetails>
                      </AccordionItem>
                        )
                  })}
            </Accordion>
            {sectionError.show && (
              <Typography variant="subtitle1" color="#C21020" textAlign="right" mt={2}>
                {sectionError.message}
              </Typography>
            )}
            <Grid container justifyContent="flex-end" mt={4}>
              <SelfServiceButtons
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                addNewhandler={addNewhandler}
                fnValidate={fnValidate}
                payloadData={payloadData}
                setPayloadData={setPayloadData}
                isPartTemplate={payloadData.templateType === CRS_SURVEY_TEMPLATES.PART}
                addNewParthandler={addNewParthandler}
                setLoader={setLoader}
              />
            </Grid>
          </Grid>}
        </CardContent>
      </Card>
    </>
  );
};

export default SectionStep;
